
const nextRaceOff = {
  component: "HorseRacingNextRaceOff",
  props: {
    displayAll: true
  },
  desktopColumn: "right",
  desktopOrder: 2,
  handheldOrder: false
};

const defaultSideBarComponents = [nextRaceOff];

const getMostFollowed = (desktopOrder, handheldOrder) => ({
  component: "HorseRacingMostFollowed",
  desktopColumn: "right",
  desktopOrder,
  handheldOrder
});

const withNoAdverts = (...components) => ({
  components: [...components, ...defaultSideBarComponents]
});

const insiderPageLayout = withNoAdverts({
    component: "InsiderBenefits",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  },
  getMostFollowed(5, 2)
);

export default {
  '/insider': insiderPageLayout
};



// WEBPACK FOOTER //
// ./modules/Insider/layouts.js